module.exports = __webpack_public_path__ + "img/sos.48de9bcd.png";